

























































































import { NotificationSectionViewFactory } from '@/components/molecules/notification-section/model/notification-section-model'
import { CartItem } from '@/models/cart/cart-item'
import NoveltySection from '@spa/components/organisms/cart/novelty/NoveltySection.vue'
import { NoveltyEntity } from '@spa/components/organisms/cart/novelty/selection'
import { WithCheckoutComponentProps } from '@spa/components/pages/order/order/checkout/mixin/with-checkout-component-props'
import PriceSummaryForCheckoutStore from '@spa/components/pages/order/order/checkout/PriceSummaryForCheckoutStore.vue'
import { CheckoutKey } from '@spa/components/pages/order/order/models/checkout-store'
import OrderListItem from '@spa/components/pages/order/order/order-list/read-only/OrderListItem.vue'
import _ from 'lodash'
import { VueConstructor } from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit } from 'vue-property-decorator'

/**
 * 1回のボタンクリックで単一のCheckoutのみ実行されるUI
 * 反対はBulkCheckout
 */
@Component({
  components: {
    NoveltySection,
    OrderListItem,
    PriceSummaryForCheckoutStore,
  },
})
export default class StepByStepCheckout extends Mixins<WithCheckoutComponentProps>(WithCheckoutComponentProps) {
  get notificationSection(): VueConstructor {
    return NotificationSectionViewFactory.create('caution', {
      type: 'with-icon',
      body: 'すぐに発送できない商品が含まれるため、決済が分割されます。該当商品をご確認ください！',
    })
  }

  shouldShowNoveltySection(checkoutKey: CheckoutKey): boolean {
    return !_.isEmpty(this.noveltyCampaign) &&
      !_.isEmpty(this.noveltyCartItems) &&
      // checkoutKeyのcheckoutがノベルティを持っていること
      this.checkoutStore.findByKey(checkoutKey).map(checkout => checkout.noveltyCount).getOrElse(0) > 0
  }

  handleResetNoveltySelection(error: Error) {
    this.emitResetNoveltySelection(error)
  }

  excludeNovelties(cartItems: CartItem[]): CartItem[] {
    return cartItems.filter(c => !c.isNovelty)
  }

  @Emit('checkout-individual')
  emitCheckout(_key: CheckoutKey) {
    // Do nothing
  }

  @Emit('states-change')
  emitAllStates(_entities: NoveltyEntity[]) {
    // Do nothing
  }

  @Emit('reset-novelty-selection')
  emitResetNoveltySelection(_error: Error): void {
    // Do nothing
  }
}
